<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.contactPrincipal')">
          <b-input v-model="signataire.contactPrincipal"></b-input>
        </b-field>
      </div>
      <div class="column is-8"></div>
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.signataireRelance')">
          <b-input v-model="signataire.signataireRelance"></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.fonctionSignataireRelance')">
          <b-input v-model="signataire.fonctionSignataireRelance"></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <input-email v-if="forSociete"
              :label="$t('general.signataire.ajout.emailSignataireRelance')"
              :value="emailSignataireRelance"
              @input="$emit('update:emailSignataireRelance', $event)"/>
      </div>
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.signataireBaux')">
          <b-input v-model="signataire.signataireBaux"></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.fonctionSignataireBaux')">
          <b-input v-model="signataire.fonctionSignataireBaux"></b-input>
        </b-field>
      </div>
      <div class="column is-4"></div>
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.signataireRecouvrement')">
          <b-input v-model="signataire.signataireRecouvrement"></b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('general.signataire.ajout.telephoneRecouvrement')">
          <b-input v-model="signataire.telephoneRecouvrement"></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import inputEmail from '@/components/general/inputEmail';

export default {
  props: {
    signataire: {
      type: Object,
      required: true,
    },
    forSociete: {
      type: Boolean,
      required: false,
      default: false,
    },
    emailSignataireRelance: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    inputEmail,
  },
};

</script>
